import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { FaHeadset } from "react-icons/fa6";
import PartnerService from "./index";
import ViewTicketDetail from "./view";

const partnerServicetRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Partner Services",
        basePath: "partner-service",
        mainComponent: <PartnerService />,
        layout: "/console",	   
        icon: <FaHeadset className="icon-item" />,
        viewComponent: <ViewTicketDetail />,
        subTitle:"Partner Service",
        level:4,
        moduleId: 0,
    })
]

export default partnerServicetRoutes;